import React from 'react';

export interface XProps {
  className?: string;
}

const X: React.FC<XProps> = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.3319 6.90402L13.5437 0.845703H12.3087L7.78327 6.10605L4.16883 0.845703H0L5.46574 8.80028L0 15.1534H1.2351L6.01406 9.59825L9.83117 15.1534H14L8.3316 6.90402H8.3319ZM6.64026 8.87036L6.08647 8.07827L1.68013 1.77547H3.57717L7.13314 6.86203L7.68693 7.65412L12.3093 14.2659H10.4122L6.64026 8.87067V8.87036Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default X;
